import { render } from "./i-logout.vue?vue&type=template&id=5af0bf64"
import script from "./i-logout.vue?vue&type=script&lang=js"
export * from "./i-logout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__